// @flow
import * as React from 'react'
import styled from 'styled-components'
import { colors } from '@components/shared/colors'
import { config } from 'react-awesome-styled-grid'
import { FadeInImage } from '@components/shared/FadeInImage'
import type { TrackPropsType } from '../../models/Track'
import { TrackListItemComponent } from '@components/Track/TrackListItem'
import type { CreatorPropsType } from '../../models/Creator'

export function CreatorDetail (props: CreatorPropsType): React.Node {
  return (
    <CreatorDetailContainer>
      <ImageAndInfoContainer>
        <ImageContainer>
          <FadeInImage src={props.imageUrl} height={500} width={500} />
        </ImageContainer>
        <CreatorInfoContainer>
          <TagPillButton>Creator</TagPillButton>
          <Title>{props.title}</Title>
         <DescriptionContainer>{props.description}</DescriptionContainer>
        </CreatorInfoContainer>
      </ImageAndInfoContainer>
      <EpsiodeInfoContainer>{props.episodeInfo}</EpsiodeInfoContainer>
      {props.tracks.map((track: TrackPropsType): React.Node => (
        <SectionDivider key={`creator-page-${props.id}-${track.id}`}>
          <TrackListItemComponent {...track} showCreator={false}/>
        </SectionDivider>
      ))}
    </CreatorDetailContainer>
  )
}

const DescriptionContainer = styled.div`
    font-family: "Good Sans Regular";
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 130%;
    letter-spacing: -0.3px;
    color: ${colors.white70};

    ${(props: any): string => config(props).media.md`
      font-size: 14px;
  `}
    ${(props: any): string => config(props).media.lg`
      font-size: 16px;
  `}
`

const Title = styled.h1`
    font-family: "Queens Condensed Light";
    font-size: 22px;
    font-style: normal;
    font-weight: 400;
    line-height: 110%;
    margin: 16px 0px;
    padding: 0;
    color: ${colors.white};
    ${(props: any): string => config(props).media.xs`
  `}
    ${(props: any): string => config(props).media.sm`
  `}
    ${(props: any): string => config(props).media.md`
      font-size: 36px;
    `}
    ${(props: any): string => config(props).media.lg`
      font-size: 48px;
    `}
    ${(props: any): string => config(props).media.xl`
  `}
`
const EpsiodeInfoContainer = styled.div`
    margin-top: 20px;
    margin-bottom: 5px;
    font-family: "Good Sans Regular";
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px; /* 125% */
    letter-spacing: -0.3px;
    color: ${colors.white};

    ${(props: any): string => config(props).media.md`
      font-size: 24px;
  `}
    ${(props: any): string => config(props).media.lg`
      font-size: 28px;
  `}

`
const SectionDivider = styled.div`
  padding: 15px 0;
  border-bottom: 1px solid ${colors.white25};
  ${(props: any): string => config(props).media.md`
    padding: 30px 0;
  `}
`
const ImageAndInfoContainer = styled.div`
    display: flex;
    align-items: center;
    ${(props: any): string => config(props).media.xs`
  `}
    ${(props: any): string => config(props).media.sm`
  `}
    ${(props: any): string => config(props).media.md`
      justify-content: center;
    `}
    ${(props: any): string => config(props).media.lg`
  `}
    ${(props: any): string => config(props).media.xl`
  `}
`
const CreatorInfoContainer = styled.div`
    flex-direction: column;
    display: flex;
    margin-left: 16px;
    max-width: 552px;
    ${(props: any): string => config(props).media.xs`
  `}
    ${(props: any): string => config(props).media.sm`
  `}
    ${(props: any): string => config(props).media.md`
    margin-left: 24px;
  `}
    ${(props: any): string => config(props).media.lg`
      margin-left: 72px;
    `}
    ${(props: any): string => config(props).media.xl`
  `}
`
const ImageContainer = styled.div`
    width: 156px;
    height: 156px;
    flex-shrink: 0;
    img {
        border-radius: 100px;
    }
    ${(props: any): string => config(props).media.xs`
  `}
    ${(props: any): string => config(props).media.sm`
  `}
    ${(props: any): string => config(props).media.md`
      width: 300px;
      height: 300px;
      img {
        border-radius: 300px;
      }
  `}
    ${(props: any): string => config(props).media.xl`
      width: 500px;
      height: 500px;
      img {
        border-radius: 500px;
      }
  `}
`
const CreatorDetailContainer = styled.div`
    display: flex;
    flex-direction: column;

    ${(props: any): string => config(props).media.xs`
  `}
    ${(props: any): string => config(props).media.sm`
  `}
    ${(props: any): string => config(props).media.md`
  `}
    ${(props: any): string => config(props).media.lg`
  `}
    ${(props: any): string => config(props).media.xl`
  `}
`

export const TagPillButton = styled.div`
  font-family: "Good Sans Regular";
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 15px; /* 136.364% */
  letter-spacing: -0.3px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 8px;
  color: ${colors.white};
  border-radius: 100px;
  border: 0.5px solid ${colors.white};
  max-width: 66px;
`
